export default "__VITE_ASSET__DTiw4MNm__"